import { Component, OnInit } from '@angular/core';
import * as firebase from 'firebase';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../../core/authentication/Authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { Language } from './../../../../core/_helpers/Language';

@Component({
  selector: 'app-after-login',
  templateUrl: './afterlogin.component.html',
  styleUrls: ['./afterlogin.component.scss']
})
export class AfterLoginComponent implements OnInit {

  public Email: string;
  public Token: string;
  public isLogin: boolean;
  public nombreUsuario: string;
  public listUser;
  public nameLabe;
  public lang;
  public ComponentView = 0;

  constructor(
    private router: Router,
    public auth: AuthenticationService,
    private translate: TranslateService,
    private language: Language) { }

  ngOnInit() {
    this.LoadProfile();
    this.router.navigate(['afterlogin/directory']);
  }

  Logout() {
    this.auth.logout()
      .then((user) => {
        this.router.navigate(['/login']);
      }, (error) => {
        alert(error.message);
      });
  }
  token() {
    firebase.auth().currentUser.getIdToken(false).then(idToken => { this.Token = idToken; }).catch(error => alert(error.message));
  }
  LoadProfile() {
    this.lang = localStorage.getItem('language');

    this.translate.use(this.lang);

    const id = localStorage.getItem('uid');
    firebase.database().ref('users/' + id).once('value').then((snapshot) => {
      const username = (snapshot.val() && snapshot.val() != null) || 'Anonymous';
      /* if (typeof snapshot.val().language !== 'undefined') {
        this.lang = snapshot.val().language;
        this.translate.setDefaultLang(this.lang);
        // this.translate.use(this.lang);
        localStorage.setItem('language', this.lang);
      } else {
        this.translate.setDefaultLang(this.lang);
      } */

      this.translate.get(['verificationTools.texto'])
        .subscribe(translations => {
          this.nameLabe = translations['verificationTools.texto'];
        });

    });
  }

  changeLeng($event) {
    this.translate.use($event);

    localStorage.setItem('language', $event);

    this.translate.get(['verificationTools.texto'])
      .subscribe(translations => {
        this.nameLabe = translations['verificationTools.texto'];
      });
  }

  eventBack($event) {
    this.ComponentView = $event;
  }

  showHeptcenter($event) {
    this.ComponentView = $event;
  }
}
